// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__Kj91H","Label":"BuildControl_Label__87mZN","Less":"BuildControl_Less__qW7Nh","More":"BuildControl_More__2-W-b"};